module.exports = __webpack_public_path__ + "img/18.b7eb7c1f.gif";